import { Data2 } from "../../../../../features/data-types"
import { Emitter, Event } from "../../../../../features/event-emitter"
import { ModalId, useUIActions } from "../../../../../features/ui"
import { useRoadmapService } from "../../../services/roadmapService"

export const useActions = () => {
    const { openModal } = useUIActions()
    const { createRoadmap } = useRoadmapService()

    const submitRoadmapOrOpenModal = async (
        data: Data2,
        branchId: string,
        shipmentsDataParam: Data2[],
        isOverloaded: boolean
    ) => {
        if (isOverloaded) {
            return openModal(ModalId.ROADMAP_WEIGHT_WARNING)
        } else {
            submitRoadmap(data, branchId, shipmentsDataParam)
        }
    }

    const submitRoadmap = async (
        data: Data2,
        branchId: string,
        shipmentsDataParam: Data2[],
    ) => {
        Emitter.emit(Event.DB_SUBMIT)

        const { driverId, vehicleId, date } = data
        const roadmapData = {
            branchId,
            driverId,
            vehicleId,
            date
        }
        const shipmentsData = shipmentsDataParam.map(shipmentData => ({
            id: shipmentData.id,
            order: shipmentData.order
        }))
        
        await createRoadmap(roadmapData, shipmentsData)
        
        Emitter.emit(Event.DB_SUBMIT_DONE)
    }

    return {
        submitRoadmapOrOpenModal,
        submitRoadmap
    }
}
